/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container, Wrapper, SocialMediaFooter } from './styles';

import Logofb from '~/assets/facebook.png';
import LogoInsta from '~/assets/instagram.png';
import LogoLinkedIn from '~/assets/icone_linkedin.png';
import { useSelector } from 'react-redux';
import history from '~/services/history';

import refera from '~/util/refera';

function Doubt(props) {

  // #region Attributes
  const [reference, setReference] = useState('');
  const [contract, setContract] = useState('');
  const [address, setAddress] = useState('');
  const property = useSelector(state => state.property.property);
  const [title, setTitle] = useState({});
  const [doubt, setDoubt] = useState({});

  const _state = useSelector(state => state);
  const userType = useSelector(state => state.user.profile.tipoCliente);

  // #endregion

  // #region Functions
  useEffect(() => {

    refera.init(_state)

    if (props && props.location && props.location.state) {
      const {
        sAddress,
        sContract,
        sReference,
        sTitle,
        sDoubt,
      } = props.location.state;
      setAddress(sAddress);
      setContract(sContract);
      setReference(sReference);
      setTitle(sTitle);
      setDoubt(sDoubt);
    }

  }, [props]);

  function openSocialMedia(socialMedia) {
    switch (socialMedia) {
      case 1:
        window.open('https://pt-br.facebook.com/ApolarImoveis');
        break;
      case 2:
        window.open('https://www.instagram.com/apolarimoveis/');
        break;
      case 3:
        window.open('https://www.linkedin.com/company/apolar-imoveis/');
        break;
      default:
        break;
    }
  }

  function handleNavigateRepairRequest() {

    refera.open(property)
    return false

    window.open("https://admin.refera.com.br/solicitar-manutencao/apolar", '_blank').focus();
    return false
    
    history.push({
      pathname: '/SolicitarReparo',
    });
  }
  // #endregion

  return (
    <Container>
      <div
        className="header"
        style={{ justifyContent: 'flex-end', flexDirection: 'column' }}
      >
        <div>
          <span>Ref.: {reference}</span>
          <span>Contrato: {contract}</span>
          <span>{address}</span>
        </div>
      </div>

      <Wrapper>
        <div className="side">
          <h2>{title.title}</h2>
          {title &&
            title.doubts &&
            title.doubts.map(d => (
              <button key={d.id} type="button" onClick={() => setDoubt(d)}>
                {d.title}
              </button>
            ))}
          {userType.indexOf('Proprietário') >= 0 &&
          title.title === 'Solicitação de Reparos' ? (
            <div className="handle-request-repair">
              <button
                type="button"
                onClick={() => handleNavigateRepairRequest()}
              >
                Solicitar um Reparo
              </button>
            </div>
          ) : (
            ''
          )}
        </div>
        <div className="content">
          <h1>{doubt ? doubt.title : 'Dúvida'}</h1>
          {doubt && doubt.corpse && (
            <div dangerouslySetInnerHTML={{ __html: doubt.corpse }} />
          )}
        </div>
      </Wrapper>

      <SocialMediaFooter>
        <button type="button" onClick={() => openSocialMedia(1)}>
          <img src={Logofb} alt="Visite nossa página do Facebook" />
        </button>

        <button type="button" onClick={() => openSocialMedia(2)}>
          <img src={LogoInsta} alt="Visite nosso Instagram" />
        </button>

        <button type="button" onClick={() => openSocialMedia(3)}>
          <img src={LogoLinkedIn} alt="Visite nosso Twitter" />
        </button>
      </SocialMediaFooter>
    </Container>
  );
}

export default Doubt;

Doubt.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
};
